import "./ProjectSettingsRibbon.css";

import { useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

import { getNorthTerrs, getNrspVers, getPriceZones, getProjectObjTypes, getProjectWorkTypes } from "slices/books/booksSelectors";
import { fetchNrspVers, fetchPriceZones } from "slices/books/services";
import { patchProject } from "slices/projects";

const ProjectSettingsRibbon = () => {
	const dispatch = useDispatch();
	const projMain = useSelector((state) => state.projectWork.main);

	const priceZone = useSelector(getPriceZones);
	const nrspVers = useSelector(getNrspVers);
	const northTerrs = useSelector(getNorthTerrs);
	const projectObjTypes = useSelector(getProjectObjTypes);
	const projectWorkTypes = useSelector(getProjectWorkTypes);

	const [selectedPriceZone, setSelectedPriceZone] = useState({});
	const [selectedNorthTerr, setSelectedNorthTerr] = useState({});
	const [selectedNrspVers, setSelectedNrspVers] = useState({});
	const [selectedProjectObjType, setSelectedProjectObjType] = useState({});
	const [selectedProjectWorkType, setSelectedProjectWorkType] = useState({});

	useLayoutEffect(() => {
		dispatch(fetchPriceZones()).then((data) => {
			setSelectedPriceZone(data.payload.find((x) => x.id === projMain.price_zone_id));
		});
		dispatch(fetchNrspVers()).then((data) => {
			setSelectedNrspVers(data.payload.find((x) => x.id === projMain.nrsp_vers_id));
		});
		setSelectedNorthTerr(northTerrs.find((x) => x.id === projMain.north_reg_terr_id));
		setSelectedProjectObjType(projectObjTypes.find((x) => x.id === projMain.object_type_id));
		setSelectedProjectWorkType(projectWorkTypes.find((x) => x.id === projMain.work_type_id));
	}, [projMain.price_zone_id, projMain.nrsp_vers_id, projMain.north_reg_terr_id, projMain.object_type_id, projMain.work_type_id]); // eslint-disable-line react-hooks/exhaustive-deps

	if (priceZone.length === 0) return;
	if (!projMain) return;
	if (!projMain.north_reg_terr_id) return;
	if (projMain.price_zone_id === undefined) return;
	if (projMain.price_zone_id && !selectedPriceZone) return;

	return (
		<div className="ProjectSettingsRibbon">
			<div className="ProjectSettingsRibbonRow">
				<Autocomplete
					sx={{ width: "100%", "& legend": { fontSize: "9px" } }}
					size="small"
					options={priceZone}
					value={selectedPriceZone || null}
					disableClearable
					getOptionLabel={(option) => option.name || ""}
					isOptionEqualToValue={(option, value) => option.name === value.name}
					noOptionsText="нет данных"
					onInputChange={(e, val) => {
						const clickedVal = priceZone.find((x) => x.name === val);
						if (clickedVal && clickedVal?.id !== selectedPriceZone?.id) {
							dispatch(patchProject({ id: projMain.id, price_zone_id: clickedVal.id }));
							setSelectedPriceZone(clickedVal);
						}
					}}
					renderInput={(params) => <TextField {...params} InputLabelProps={{ shrink: true }} label="Ценовая зона" />}
				/>
				<Autocomplete
					sx={{ width: "100%", "& legend": { fontSize: "9px" } }}
					size="small"
					options={northTerrs}
					value={selectedNorthTerr || null}
					disableClearable
					getOptionLabel={(option) => option.name || ""}
					isOptionEqualToValue={(option, value) => option.name === value.name}
					noOptionsText="нет данных"
					onInputChange={(e, val) => {
						const clickedVal = northTerrs.find((x) => x.name === val);
						if (clickedVal && clickedVal?.id !== selectedNorthTerr?.id) {
							dispatch(patchProject({ id: projMain.id, north_reg_terr_id: clickedVal.id }));
							setSelectedNorthTerr(clickedVal);
						}
					}}
					renderInput={(params) => <TextField {...params} InputLabelProps={{ shrink: true }} label="Признак территории" />}
				/>
			</div>
			<div className="ProjectSettingsRibbonRow Top">
				<Autocomplete
					sx={{ width: "100%", "& legend": { fontSize: "9px" } }}
					size="small"
					options={projectObjTypes}
					value={selectedProjectObjType || null}
					disableClearable
					getOptionLabel={(option) => option.name || ""}
					isOptionEqualToValue={(option, value) => option.name === value.name}
					noOptionsText="нет данных"
					onInputChange={(e, val) => {
						const clickedVal = projectObjTypes.find((x) => x.name === val);
						if (clickedVal && clickedVal?.id !== selectedProjectObjType?.id) {
							dispatch(patchProject({ id: projMain.id, object_type_id: clickedVal.id }));
							setSelectedProjectObjType(clickedVal);
						}
					}}
					renderInput={(params) => <TextField {...params} InputLabelProps={{ shrink: true }} label="Тип объекта" />}
				/>
				<Autocomplete
					sx={{ width: "100%", "& legend": { fontSize: "9px" } }}
					size="small"
					options={projectWorkTypes}
					value={selectedProjectWorkType || null}
					disableClearable
					getOptionLabel={(option) => option.name || ""}
					isOptionEqualToValue={(option, value) => option.name === value.name}
					noOptionsText="нет данных"
					onInputChange={(e, val) => {
						const clickedVal = projectWorkTypes.find((x) => x.name === val);
						if (clickedVal && clickedVal?.id !== selectedProjectWorkType?.id) {
							dispatch(patchProject({ id: projMain.id, work_type_id: clickedVal.id }));
							setSelectedProjectWorkType(clickedVal);
						}
					}}
					renderInput={(params) => <TextField {...params} InputLabelProps={{ shrink: true }} label="Вид работ" />}
				/>
			</div>
			<div className="ProjectSettingsRibbonRow Top">
				<Autocomplete
					sx={{ width: "100%", "& legend": { fontSize: "9px" } }}
					size="small"
					options={nrspVers}
					value={selectedNrspVers || null}
					disableClearable
					getOptionLabel={(option) => option.name || ""}
					isOptionEqualToValue={(option, value) => option.name === value.name}
					noOptionsText="нет данных"
					onInputChange={(e, val) => {
						const clickedVal = nrspVers.find((x) => x.name === val);
						if (clickedVal && clickedVal?.id !== selectedNrspVers?.id) {
							dispatch(patchProject({ id: projMain.id, nrsp_vers_id: clickedVal.id }));
							setSelectedNrspVers(clickedVal);
						}
					}}
					renderInput={(params) => <TextField {...params} InputLabelProps={{ shrink: true }} label="Номер приказа НРСП" />}
				/>
			</div>
		</div>
	);
};

export default ProjectSettingsRibbon;
